import { Component, OnInit } from "@angular/core";
import { expandingFabAnimations } from "@/_utility/animations";
import { Observable, combineLatest } from "rxjs";
import { TabItem } from "@/_models/menu-item";
import { MenuService } from "@/_services/menu.service";
import { map } from "rxjs/operators";
import { StatsSharedService } from "@/_services/stats-shared.service";

@Component({
    templateUrl: "./statistics.component.html",
    styleUrls: ["./statistics.component.scss"],
    animations: [expandingFabAnimations],
    providers: [StatsSharedService],
})
export class StatisticsComponent implements OnInit {
    navTabs$: Observable<TabItem[]>;
    currentTab$: Observable<TabItem>;
    showExportButton$: Observable<boolean>;

    constructor(
        private menuService: MenuService,
        private statsSharedService: StatsSharedService,
    ) {}

    ngOnInit(): void {
        this.navTabs$ = this.menuService.createPerformanceMenu();
        this.currentTab$ = this.menuService.getCurrentTab(this.navTabs$);

        this.showExportButton$ = combineLatest([
            this.currentTab$,
            this.statsSharedService.isSingleStatMode$,
        ]).pipe(
            map(([currentTab, isSingleStatMode]) => {
                return (
                    currentTab?.link === "/performance/reports" &&
                    isSingleStatMode
                );
            }),
        );
    }

    onExportInsights(): void {
        this.statsSharedService.requestExport();
    }
}
